import React from 'react'

import { ThemeProvider } from '@material-ui/core/styles'
import { ThemeProvider as ThemeProviderV5 } from '@mui/material'
import { LicenseInfo } from '@mui/x-data-grid-pro'
import { ErrorBoundary } from '@scoir/error-reporter'
import theme, { themeV5 } from 'material/theme'
import { Provider } from 'react-redux'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { RouterToUrlQuery } from 'react-url-query'

import ErrorReporter from 'components/ErrorReporter'
import MUI_PRO_KEY from 'components/MuiPro/key'

import './App.scss'
import AppStartup from './AppStartup'
import './bootstrap.scss'
import Login from './routes/Login'
import store from './store'

class App extends React.Component {
  constructor() {
    super()
    LicenseInfo.setLicenseKey(MUI_PRO_KEY)
  }

  render() {
    const ROOT_PATH = import.meta.env.BASE_URL
    return (
      <ErrorReporter>
        <ErrorBoundary>
          <ThemeProviderV5 theme={themeV5}>
            <ThemeProvider theme={theme}>
              <BrowserRouter>
                <Provider store={store}>
                  <RouterToUrlQuery>
                    <Switch>
                      {import.meta.env.DEV && (
                        <Route
                          exact
                          path={`${ROOT_PATH}/login`}
                          component={Login}
                        />
                      )}
                      <Route
                        path={ROOT_PATH}
                        component={AppStartup}
                      />
                    </Switch>
                  </RouterToUrlQuery>
                </Provider>
              </BrowserRouter>
            </ThemeProvider>
          </ThemeProviderV5>
        </ErrorBoundary>
      </ErrorReporter>
    )
  }
}

export default App
